const axios = require("axios");
import firebase from "firebase";
const db = firebase.firestore();

const sendNotification = function(
  subject,
  user_ids,
  comm_types,
  msg,
  from = null,
  template_id = null,
  notif_type = "welcome",
  settings_override = true
) {
  return new Promise((resolve, reject) => {
    //const functions = getFunctions();
   // const genericemail = httpsCallable(functions, 'genericemail');
   // let genericemail = firebase.functions().httpsCallable('genericemail');


    user_ids.forEach(async user => {
      if (typeof user === "object") {
        comm_types.forEach(notify_type => {
          switch (notify_type) {
            case "email":
              genericemail(payload)
                  .then((result) => {
                    // Read result of the Cloud Function.
                    var sanitizedMessage = result.data.text;
                  })
                  .catch((error) => {
                    // Getting the Error details.
                    var code = error.code;
                    var message = error.message;
                    var details = error.details;
                    // ...
                  });
              break;
            case "sms":
              axios({
                method: "post",
                url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                data: {
                  to: user.phoneNumber,
                  type: "sms",
                  msg: msg,
                  from: from
                }
              })
                .then(res => {
                  resolve(res);
                })
                .catch(e => {
                  reject(e);
                });
              break;
            case "whatsapp":
              axios({
                method: "post",
                url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                data: {
                  to: user.phoneNumber,
                  type: "whatsapp",
                  msg: msg,
                  from: from
                }
              })
                .then(res => {
                  resolve(res);
                })
                .catch(e => {
                  reject(e);
                });
              break;
            case "voice":
              axios({
                method: "post",
                url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                data: {
                  to: user.phoneNumber,
                  type: "voice",
                  msg: msg,
                  from: from
                }
              })
                .then(res => {
                  resolve(res);
                })
                .catch(e => {
                  reject(e);
                });
              break;
            case "inbox":
              //Add to users notifications
              break;
            default:
              reject({
                message: "method not found",
                code: 404,
                status: "error"
              });
              break;
          }
        });
      } else if (typeof user === "string") {
        //check to see if it is an email
        let email = null;
        let user_data = null;

        if (user && user.indexOf("@") > -1) {
          //email address
          email = user;
        } else {
          const userRef = db.collection("users").doc(user);
          const user_doc = await userRef.get();
          user_data = user_doc.data();

          if (user_data) {
            email = user_data.email;
          }
        }

        if ((user_data && user_data.settings) || settings_override) {
          console.log(`email is ${email}`);
          console.log(`msg is ${msg}`);
          console.log(`subject is ${subject}`);
          console.log(`template id  is ${template_id}`);

          comm_types.forEach(notify_type => {
            switch (notify_type) {
              case "email":
                if (
                  (user_data &&
                    user_data.settings &&
                    user_data.settings.notifications.email) ||
                  settings_override
                ) {
                  debugger;
                  //can be emailed
                  const payload =  {
                    subject: subject,
                    to: user_data.email,
                    type: "email",
                    msg: msg,
                    from: from,
                    templateId: template_id
                  };

                  genericemail(payload)
                      .then((result) => {
                        // Read result of the Cloud Function.
                        var sanitizedMessage = result.data.text;
                      })
                      .catch((error) => {
                        // Getting the Error details.
                        var code = error.code;
                        var message = error.message;
                        var details = error.details;
                        // ...
                      });
                } else {
                  reject({
                    message: "No Email Address found.",
                    status: "error"
                  });
                }
                break;

              case "push":
                if (user_data.device_registratons) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${dbName}.cloudfunctions.net/send_notification`,
                    data: {
                      subject: subject,
                      to: user_data,
                      type: "push",
                      msg: msg,
                      from: from,
                      device_token: user_data.device_registratons[0].token
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Token found.",
                    status: "error"
                  });
                }
                break;

              case "sms":
                if (
                  user_data.settings.notifications.mobile &&
                  user_data.phoneNumber
                ) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${dbName}.cloudfunctions.net/send_notification`,
                    data: {
                      to: user_data.phoneNumber,
                      type: "sms",
                      msg: msg,
                      from: from
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Phone Number found.",
                    status: "error"
                  });
                }
                break;

              case "whatsapp":
                if (
                  user_data.settings.notifications.mobile &&
                  user_data.phoneNumber
                ) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${dbName}.cloudfunctions.net/send_notification`,
                    data: {
                      to: user_data.phoneNumber,
                      type: "whatsapp",
                      msg: msg,
                      from: from
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Phone Number found.",
                    status: "error"
                  });
                }
                break;

              case "voice":
                if (
                  user_data.settings.notifications.mobile &&
                  user_data.phoneNumber
                ) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${dbName}.cloudfunctions.net/send_notification`,
                    data: {
                      to: user_data.phoneNumber,
                      type: "voice",
                      msg: msg,
                      from: from
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Phone Number found.",
                    status: "error"
                  });
                }
                break;

              case "messenger":
                if (user_data.settings.notifications.mobile) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${dbName}.cloudfunctions.net/send_notification`,
                    data: {
                      to: user_data.messengerId,
                      type: "messenger",
                      msg: msg
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Messenger Id found.",
                    status: "error"
                  });
                }
                break;

              case "slack":
                if (user_data.settings.notifications.mobile) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${dbName}.cloudfunctions.net/send_notification`,
                    data: {
                      to: "C018G36ECKV",
                      type: "slack",
                      msg: msg
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Slack Id found.",
                    status: "error"
                  });
                }
                break;

              default:
                reject({
                  message: "method not found",
                  code: 404,
                  status: "error"
                });
                break;
            }
          });
        } else {
          reject({
            message: "Notifications are off for this user.",
            status: "error"
          });
        }
      }
    });
  })
    .then(resolve => {
      console.log(resolve);
    })
    .catch(reject => {
      debugger;
      alert(reject);
    });
};

function permissionCheck(commType, user) {
  return true;
}
export default sendNotification;
